import { GlobalWorkerOptions } from 'pdfjs-dist'

GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString()

// Assets servis par le plugin pdfjsAssets() (packages/ui/vite/pdfjsAssets.ts),
// à brancher dans le vite.config de chaque app qui utilise le FileUploadBox.
// Les URLs doivent finir par '/' : pdfjs y concatène le nom de fichier.
const base = import.meta.env.BASE_URL

export const PDFJS_DOC_ASSETS = {
    wasmUrl: `${base}pdfjs/wasm/`,
    cMapUrl: `${base}pdfjs/cmaps/`,
    cMapPacked: true,
    standardFontDataUrl: `${base}pdfjs/standard_fonts/`
}
